export const tsunami = {
  name: `tsunami`,
  sql: `
    SELECT * FROM solano_tsu
    WHERE haz_tsu IN ('Yes')
    `,
  cartoCSS: `
    #layer {
      polygon-fill: ramp([haz_tsu], (#000), ("Yes"), =);
      polygon-opacity: 0.58;
      polygon-comp-op: overlay;
    }
    #layer::outline {
      line-width: 1;
      line-color: #FFFFFF;
      line-opacity: 0.5;
    }
  `,
}